import React from 'react'
import PropTypes from 'prop-types'

import { withProps } from 'recompose'

import MuiTextField from '@material-ui/core/TextField'
import MuiInputAdornment from '@material-ui/core/InputAdornment'

import CsgTooltipEllipsis from 'components/atoms/ToolTipEllipsis'

import styled, { css } from 'styled-components'

import theme from 'app/theme'

const StyledTextField = styled(MuiTextField)`
  && {
    & > div {
      margin-top: 20px;
      padding-bottom: 6px;
    }
  }
`

const Input = styled(({ color, padding, white, upper, endIcon, searchIcon, icon, hasTooltip, ...props }) => {
  const { value, maxTooltipWidth = 200 } = props
  return (
    <>
      {hasTooltip ? (
        <StyledTextField
          InputLabelProps={{ shrink: true }}
          {...props}
          InputProps={{
            ...props.InputProps,
            inputComponent: () => <CsgTooltipEllipsis text={value} maxWidth={maxTooltipWidth} />
          }}
        />
      ) : (
        <MuiTextField {...props} />
      )}
    </>
  )
})`
  ${props =>
    props.typeNumber &&
    css`
    &&  {
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type='number'] {
        -moz-appearance: textfield;
      }
  `};

  ${props =>
    props.InputProps &&
    props.InputProps.startAdornment &&
    css`
      && > label {
        margin-left: 40px;
      }
    `};

  ${props =>
    props.InputProps &&
    props.InputProps.startAdornment &&
    props.InputProps.endAdornment &&
    css`
      && > div {
        input {
          margin-left: 10px;
        }
      }
      && > div {
        textarea {
          margin-left: 10px;
        }
      }
    `};

  ${props =>
    props.InputProps &&
    props.InputProps.endAdornment &&
    css`
      && > div {
        margin-right: 0px;
      }
      ,
      && > div > div {
        margin-right: 0px;
      }
    `};

  ${props =>
    props.InputProps &&
    props.InputProps.endAdornment &&
    props.InputProps.inputVisibilityOff &&
    css`
      @font-face {
        font-family: text-security-disc;
        src: url('https://raw.githubusercontent.com/noppa/text-security/master/dist/text-security-disc.woff');
      }
      && > div > input {
        -webkit-text-security: disc;
        font-family: text-security-disc;
      }
    `};

  ${props =>
    props.color &&
    css`
      && > label {
        color: ${theme.palette[props.color].main};
      }
    `};

  ${props =>
    props.padding &&
    css`
      && > div {
        input {
          padding-bottom: ${theme.spacing(2)}px;
        }

        & > div > svg,
        > div > button {
          margin-bottom: ${theme.spacing(2)}px;
        }
      }
    `};

  ${props =>
    props.white &&
    css`
      && {
        > label {
          color: ${theme.palette.common.white};
        }

        > div > input:focus,
        > label {
          color: ${theme.palette.common.white} !important;
        }

        > div {
          color: ${theme.palette.common.white} !important;

          > div > svg {
            color: ${theme.palette.common.white} !important;
          }

          &:before,
          &:after {
            border-bottom-color: ${theme.palette.common.white} !important;
          }
        }
      }
    `};
  ${props =>
    props.upper &&
    css`
      && > div {
        input {
          text-transform: uppercase;
        }
      }
    `}
`

export const EndInputAdornment = styled(MuiInputAdornment)`
  && {
    margin-right: 0;

    ${props =>
      props.disabled &&
      css`
        && {
          > div > input {
            cursor: not-allowed;
          }
        }
      `}
  }
`

Input.defaultProps = {
  type: 'text',
  margin: 'dense',
  fullWidth: true,
  autoComplete: 'new-password'
}

Input.propTypes = {
  ...MuiTextField.propTypes,
  icon: PropTypes.node,
  white: PropTypes.bool,
  upper: PropTypes.bool,
  padding: PropTypes.bool,
  endIcon: PropTypes.node,
  searchIcon: PropTypes.node,
  typeNumber: PropTypes.bool,
  hasTooltip: PropTypes.bool,
  maxTooltipWidth: PropTypes.number
}

const enhance = withProps(
  ({ icon, endIcon, searchIcon, InputProps }) =>
    (icon || endIcon || searchIcon) && {
      InputProps: {
        startAdornment: icon && <MuiInputAdornment position="start">{icon}</MuiInputAdornment>,
        endAdornment: (endIcon || searchIcon) && (
          <EndInputAdornment>
            {searchIcon}
            {endIcon}
          </EndInputAdornment>
        ),
        ...InputProps
      }
    }
)

export default enhance(Input)
